<template>
  <div>
    <div class="widget">
      <div class="widget-label">
        <div class="label">
          <p>New {{ type }}</p>
        </div>
        <b-button
          v-if="checkStatus"
          @click="openModal('add-modal')"
          variant="primary"
          class="right-align"
        >
          Add New {{ type }}
        </b-button>
      </div>

      <div class="widget-content">
        <ProjectMetricEntries
          :projectMetrics="projectMetrics.slice(0, length)"
          :fields="fields"
          @refresh="refreshItems"
        ></ProjectMetricEntries>
        <div class="btn-wrapper">
          <b-button
            v-if="projectMetrics.length > length"
            @click="$refs[`view-all`].show()"
            variant="tertiary"
            class="view"
          >
            View All
          </b-button>
          <b-modal ref="view-all" :title="type" ok-title="Close" ok-only>
            <ProjectMetricEntries
              :projectMetrics="projectMetrics"
              :fields="fields"
              @refresh="refreshItems"
            ></ProjectMetricEntries>
          </b-modal>
        </div>
      </div>
    </div>
    <EditProjectMetricModal
      ref="add-modal"
      mode="Add"
      :projectId="projectId"
      :title="`New ${type}`"
      :meetingId="meetingId"
      :possibleAssignees="projectUsers"
      :addTypes="[type]"
      :presetTags="projectTags"
      :dataTemplate="dataTemplate"
      @submit="loadItems"
    />
  </div>
</template>

<script>
import ProjectMetricEntries from "@/components/list-entries/ProjectMetricEntries.vue";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";
export default {
  name: "ActionItems",
  components: {
    ProjectMetricEntries,
    EditProjectMetricModal,
  },
  props: {
    length: {
      type: Number,
      default: 6,
    },
    type: {
      type: String,
      required: true,
    },
    projectMetrics: {
      type: Array,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    meetingId: {
      type: String,
      required: true,
    },
    projectUsers: {
      type: Array,
      required: true,
    },
    projectTags: {
      type: Array,
      required: true,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      dataTemplate: {
        overrides: [
          {
            actions: ["Add"],
            key: "status",
            value: "Closed",
          },
        ],
      },
      fields: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
      ],
    };
  },
  methods: {
    refreshItems(id) {
      this.$emit("refresh", {
        name: "project-metrics",
        id: id,
        new: true,
      });
    },
    loadItems() {
      this.$emit("load");
    },
    openModal(ref) {
      this.$refs[ref].show();
    },
  },
  computed: {
    checkStatus() {
      return this.status !== "Closed";
    },
  },
};
</script>

<style lang="scss" scoped>
</style>